/**
 * Monta o menu no formato do Sidebar da lib ($mainMenu e $subMenu) a partir de
 * uma lista de entradas, na ordem do menu:
 * - link: { key, label, icon, route }
 * - grupo: { key, label, icon, items: [links] }, que abre o painel secundário.
 * Itens `false` (sem permissão) somem. Grupo sem item visível some, e grupo com
 * um só item vira link direto (com o rótulo e o ícone do item).
 */
export function buildSidebarMenu(entries) {
  const mainMenu = {};
  const subMenu = {};

  entries.filter(Boolean).forEach((entry) => {
    if (!entry.items) {
      mainMenu[entry.key] = { name: entry.label, route: entry.route, icon: entry.icon, show: true };
      return;
    }

    const items = entry.items.filter(Boolean);
    if (!items.length) return;

    if (items.length === 1) {
      const [item] = items;
      mainMenu[item.key] = { name: item.label, route: item.route, icon: item.icon, show: true };
      return;
    }

    mainMenu[entry.key] = { name: entry.label, route: "", subMenu: entry.key, icon: entry.icon, show: true };
    items.forEach((item) => {
      subMenu[item.key] = { name: item.label, route: item.route, subMenu: entry.key, icon: item.icon, show: true };
    });
  });

  return { mainMenu, subMenu };
}
